import { render, staticRenderFns } from "./CardProducer.vue?vue&type=template&id=644156b8&scoped=true"
import script from "./CardProducer.js?vue&type=script&lang=js&external"
export * from "./CardProducer.js?vue&type=script&lang=js&external"
import style0 from "./CardProducer.scss?vue&type=style&index=0&id=644156b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644156b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default})
